export default class ModalHelper {
    constructor() {
        const template = `
            <div class="modal-background-wrap hidden" onClick="storePickup.modalHelper.closeModal();"></div>
            <div class="crisp-modal-window hidden">
                <a class="modal-closer" onClick="storePickup.modalHelper.closeModal();">
                    <svg viewBox="0 0 100 100" data-test="modal-close-button"><path d="M76.875 12.25l-29 29 29 29-7.375 7.375-29-29-29 29-7.375-7.375 29-29-29-29L11.5 4.875l29 29 29-29z"></path></svg>
                </a>
                <div class="crisp-modal-content"></div>
            </div>
        `;

        const body = document.querySelector('body');
        body.insertAdjacentHTML('beforeend', template);

        this.background = document.querySelector('.modal-background-wrap');
        this.modal = document.querySelector('.crisp-modal-window')
        this.content = document.querySelector('.crisp-modal-window .crisp-modal-content')
    }

    showModalWithContent(idOfContent) {
        const content = document.getElementById(idOfContent);
        this.background.classList.remove('hidden');
        this.modal.classList.remove('hidden');
        this.content.innerHTML = content.innerHTML;
    }

    closeModal() {
        this.background.classList.add('hidden');
        this.modal.classList.add('hidden');
        this.content.innerHTML = '';
    }
}
